import { PoolName } from '~constants/pools'
import { IVesselManager } from '~hooks/queries/vessels/vessels-types'

export enum VesselStatus {
  INCOMING = 'incoming',
  ARCHIVED = 'archived',
  ONBOARDED = 'onboarded',
  ONBOARDING = 'onboarding',
  COMMERCIAL_MANAGEMENT = 'commercial-management',
  OUTSIDE_POOL = 'outside-pool',
  TC_OUT = 'tc-out',
}

export enum TrackFieldValue {
  EARNINGS_SIMULATION = 'earnings-simulation',
  POOL = 'pool',
  COMMERCIAL_MANAGEMENT = 'commercial-management',
  ONBOARDING = 'onboarding',
  OUTSIDE_POOL = 'outside-pool',
  TC_OUT = 'tc-out',
}

export interface ISelect {
  label: string
  value: string
}

export interface VesselCertificate {
  certificate: string
  type: string
  vesselName: string
}

export const vesselTrackOptions = [
  { label: 'Pool', value: 'pool' },
  { label: 'Commercial Management', value: 'commercial-management' },
  { label: 'Outside Pool', value: 'outside-pool' },
  { label: 'TC Out', value: 'tc-out' },
  { label: 'Earnings Simulation', value: 'earnings-simulation' },
] as const satisfies readonly ISelect[]

export type VesselTrack = (typeof vesselTrackOptions)[number]['value']

const poolNames = Object.values(PoolName)
export const pools: ISelect[] = poolNames.map((name) => ({
  label: name,
  value: name,
}))

export interface IVesselData {
  imoNumber?: string
  manager?: IVesselManager
  pool?: string
  poolPartner?: string
  status?: string
  targetDate?: string
  track?: string
  vesselName?: string
  voyageManager?: string
}
